import Swiper from 'swiper'
import forEach from 'lodash/forEach'

export default function slider() {
  let index = 0

  forEach(document.querySelectorAll('.carousel-slider .swiper-container'), (container) => {
    const id = `swiper-${(index += 1)}`
    const delay = parseInt(container.getAttribute('data-swiper-autoplay'), 10)

    container.setAttribute('id', id)

    /* eslint-disable */
    const swiper = new Swiper(`#${id}`, {
      slidesPerView: 'auto',
      centeredSlides: true,
      loop: true,
      disableOnInteraction: true,
      autoplay: {
        delay: !isNaN(delay) ? delay : (1000 * 10)
      },
      observer: true,
      observeParents: true,
      threshold: 10,
      pagination: {
        el: '.carousel-slider .swiper-pagination',
        clickable: false,
      },
      navigation: {
        nextEl: '.carousel-slider .swiper-button-next',
        prevEl: '.carousel-slider .swiper-button-prev',
      },
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
        firstSlideMessage: 'This is the first slide'
      },
      on: {
        touchEnd: () => {
          setTimeout(() => {
            const sliderId = document.querySelector('.swiper-slide-active').getAttribute('data-swiper-slide-index')
            if (dataLayer) {
              try {
                dataLayer.push({
                  'event': 'show_slide',
                  'slide_number': sliderId
                })
              } catch (e) {
                console.warn('failed to push tag to dataLayer')
              }
            }
          }, 300)
        },
        slideChangeTransitionEnd: function () {
          const slides = container.querySelectorAll('.swiper-slide')
          for (let index = 0; index < slides.length; index++) {
            const element = slides[index]
            let elementsInsideSlide = element.querySelectorAll('a, button, img')

            if (element.classList.contains('swiper-slide-active')) {
              element.setAttribute('tabindex', 0)
              for (let i = 0; i < elementsInsideSlide.length; i++) {
                let element = elementsInsideSlide[i]
                element.setAttribute('tabindex', 0)
              }
            } else {
              for (let i = 0; i < elementsInsideSlide.length; i++) {
                let element = elementsInsideSlide[i]
                element.setAttribute('tabindex', -1)
              }
              element.setAttribute('tabindex', -1)
              element.setAttribute('disabled', true)
            }
          }
        }
      }
    })


    const slides = container.querySelectorAll('.swiper-slide')
    for (let index = 0; index < slides.length; index++) {
      const element = slides[index]
      if (element) {
        if (element.getElementsByClassName('sr-only').length > 0) {
          element.getElementsByClassName('sr-only')[0].innerHTML += ` ${parseInt(element.getAttribute('data-swiper-slide-index'), 10) + 1}`
        }
        element.addEventListener('focus', function () {
          swiper.autoplay.stop()
        })
      }
    }
    /* eslint-enable */
  })
}
